class UgcVideos extends HTMLElement {
  constructor() {
    super();

    this.slidesCount = +this.dataset.slides;
    this.slidesToShow = +this.dataset.slidesToShow;
    this.slidesToShowMobile = +this.dataset.slidesToShowMobile;
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', (event) => {
      this.checkAndInitSlider();
    });

    window.addEventListener('resize', (event) => {
      this.checkAndInitSlider();
    });
  }

  checkAndInitSlider() {
    if (window.innerWidth < 750) {
      this.initSlider();
    } else {
      if (this.slidesCount > this.slidesToShow) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    this.updateSlideImageHeight();
  }

  initSlider() {
    // Destroy existing slider first
    this.destroySlider();

    const self = this;
    setTimeout(() => {
      const sliderElement = self.querySelector('.ugc-videos-slider ul');
      if (sliderElement && !sliderElement.classList.contains('flickity-enabled')) {
        const slides = sliderElement.querySelectorAll('.ugc-videos--item');
        if (slides.length > 1) {
          self.flickity = new Flickity(sliderElement, {
            accessibility: false,
            prevNextButtons: true,
            pageDots: false,
            autoPlay: false,
            wrapAround: true,
            cellAlign: 'center',
            arrowShape: { x0: 10, x1: 60, y1: 50, x2: 65, y2: 45, x3: 20 },
            on: {
              select: function(index) {
                slides.forEach((slide, i) => {
                  if (index === i) {
                    if (slide.querySelector('.ugc-videos__product')) {
                      slide.querySelector('.ugc-videos__product').style.display = 'flex';
                    }
                  } else {
                    if (slide.querySelector('.ugc-videos__product')) {
                      slide.querySelector('.ugc-videos__product').style.display = 'none';
                    }
                  }
                })
              },
              change: function(index) {
                slides.forEach((slide, i) => {
                  const mediaButton = slide.querySelector('.js-deferred-video-play-button')
                  const playButton = slide.querySelector('.js-deferred-video-play-button-icon-play')
                  const pauseButton = slide.querySelector('.js-deferred-video-play-button-icon-pause')
                  const deferredImage = slide.querySelector('[id^="Deferred-Poster-"]');
                  const mediaObj = slide.querySelector('video')
                  const autoplay = slide.dataset.autoplay === 'true';

                  if (index === i) {
                    if(autoplay) {
                      if(mediaObj) {
                        mediaObj.play()
                        playButton.classList.add('visually-hidden')
                        pauseButton.classList.remove('visually-hidden')
                      } else {
                        deferredImage.click()
                      }
                    }
                  } else {
                    if(mediaButton && mediaObj) {
                      mediaObj.pause()
                      playButton.classList.remove('visually-hidden')
                      pauseButton.classList.add('visually-hidden')
                    }
                  }
                })
              }
            }
          });

          // Add click event to each slide to select it
          slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              self.flickity.select(index);
            });
          });
        } else {
          console.log('Not enough slides to initialize slider:', slides.length);
        }
      }

      this.updateSlideImageHeight();
    }, 200);
  }

  destroySlider() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }

    // Also remove any flickity classes that might be left
    const sliderElement = this.querySelector('.ugc-videos-slider ul');
    if (sliderElement) {
      sliderElement.classList.remove('flickity-enabled', 'flickity-rtl', 'flickity-enabled-is-draggable');
    }
  }

  updateSlideImageHeight() {
    const animEl = this.querySelector('use-animate');
    if (!animEl) return;
    const height = animEl.getBoundingClientRect().height;
    this.style.setProperty('--slide-image-height', `${height}px`);
  }

  disconnectedCallback() {
    this.destroySlider();
  }
}

customElements.define('ugc-videos', UgcVideos);